import axios from "axios";

export function getTransferItemProductList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/distributor/admin/api/v1/transfer/${parameters.id}/get-transfer-products`,
        {
          params: {
            length: parameters.length,
            start: parameters.start,
          },
        }
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
